import EventAgent from '@hotmart/event-agent-js';
import { DatahubEntity, CaptureEventData, DatahubAction } from 'src/interfaces/Datahub';
import { isDevelopment } from '../envUtils';
import { EVENT_VERSION, SYSTEM } from './constants';

EventAgent.mode = process.env.APP_ENV as typeof EventAgent.mode;

export const sendEvent = (entity: DatahubEntity, action: DatahubAction, data: CaptureEventData) => {
  if (isDevelopment()) return;

  const { data_version, event } = data;

  EventAgent.send({
    event_version: EVENT_VERSION,
    data_version,
    system: SYSTEM,
    entity,
    action,
    event,
  });
};
